export default "__VITE_ASSET__Dm8tip$G__"